import * as React from 'react';
import classnames from 'classnames';

import './table-top.scss';

type Props = {
  title?: string,
  message?: string,
  children?: React.ReactNode,
  className?: string
};

class TableTop extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { title, message, children, className } = this.props;

    const containerClasses = classnames('table-top', className);

    return (
      <div className={containerClasses}>
        {
          title && (
            <span className="table-top__title">{title}</span>
          )
        }
        {
          message && (
            <span className="table-top__message">{message}</span>
          )
        }
        {children}
      </div>
    );
  }
}

export default TableTop;
